import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import {
    CommonService,

    SampleService
} from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./samplePrint.html",
})
export class SamplePrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  collardata: any;
  collarList: any;
  mode: string;
  list: any = [];
  sampleData: any = {};
  styleData: any;
  matchList: any;
  @Input() set sampledata(data) {
    this.sampleData = data;
    console.log(this.sampleData);
    if (this.sampleData) {
      this.loadeditsamplelist(this.sampleData);
      this.collardata = this.commonService.itemMaster();
      let style = this.sampleData.style,
        collarstyle = this.sampleData.collar_no;
      this.collarList = this.collardata.data[
        "collar_no_" + style + "_" + collarstyle
      ];
      console.log(this.collarList);
    }
  }

  @Input() set styledata(data) {
    this.styleData = data;

    console.log(this.styleData);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;

  constructor(
    public store: Store<fromRootStore.State>,
    private commonService: CommonService,
    private sampService: SampleService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    public datePipe: DatePipe
  ) {
    console.log(this.sampleData);
  }

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
      //this.loadFinyearList();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "partySave" && this.partyForm.valid) {
      //this.onSaveSeason();
    } else {
      $("#" + nextEl).focus();
    }
  }
  loadeditsamplelist(data) {
    let params = {
      samp_id: data.samp_id,
    };
    this.sampService.getEditSampleList(params).then((res: any) => {
      // res.data = res.data.concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data);
      let list = [],
        list2 = [],
        count = 0;
      for (let i = 0; i < res.data.length; i++) {
        const li = res.data[i];
        list2.push(li);
        count++;
        if (count >= 5) {
          list.push([].concat(list2));
          list2 = [];
          count = 0;
        }
      }
      if (list2.length) {
        list.push([].concat(list2));
      }
      this.list = list;
      console.log(this.matchList);
    });
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;
    var mywindow = window.open("", "Print", "height=950,width=800");

    mywindow.document.write(content);

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/samplePrint.ts